import { useRouter } from 'next/router';
import { useState } from 'react';

import {
  Answer,
  ButtonStyled,
  Header,
  HeaderLine,
  Icon,
  Item,
  Question,
  Text,
  Wrapper,
} from './FAQ.styles';

export enum TypeType {
  HOMEPAGE = 'HOMEPAGE',
  SUPPLIER = 'SUPPLIER',
  MANAGER = 'MANAGER',
  SUPPORT = 'SUPPORT',
}

export interface FAQType {
  question: string;
  answer: string;
  type: TypeType[];
}

export interface FAQProps {
  faqs: FAQType[];
  showMore?: boolean;
}

const FAQ = ({ faqs, showMore = true }: FAQProps): JSX.Element => {
  const [open, setOpen] = useState([false, false]);
  const router = useRouter();

  const handleClick = (clickedItemIndex) => {
    const newState = [...open];
    newState[clickedItemIndex] = !newState[clickedItemIndex];
    setOpen(newState);
  };

  return (
    <Wrapper id="faq">
      <Header>FAQs</Header>
      <HeaderLine />
      {faqs.map((faq, index) => (
        <Item key={faq.question}>
          <Question onClick={() => handleClick(index)}>
            <Text>{faq.question}</Text>
            <Icon open={open[index]} />
          </Question>
          <Answer
            show={open[index]}
            dangerouslySetInnerHTML={{ __html: faq.answer }}
          />
        </Item>
      ))}
      {showMore && (
        <ButtonStyled
          kind="primary"
          text="More"
          onClick={() => router.push('/support')}
        />
      )}
    </Wrapper>
  );
};

export default FAQ;
